import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { NEW_SUPPLIER_PATH, SUPPLIER_PATH } from '../../../../config/paths';
import { SUPPLIERS_COLUMNS } from '../../../../config/columns';
import {
  clearSuppliers,
  getSuppliers,
} from '../../../../actions/food/Supplier';

export const Suppliers = ({
  breadcrumbs,
  suppliers,
  loading,
  dispatchGetSuppliers,
  dispatchClearSuppliers,
}) => {
  useLayoutEffect(() => () => dispatchClearSuppliers(), []);

  const data = suppliers.get('content') || [];
  const pages = suppliers.get('totalPages') || null;
  const defaultPageSize = suppliers.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Lista de Proveedores"
      breadcrumbs={breadcrumbs}
      buttonPath={NEW_SUPPLIER_PATH}
      tableStructure={{
        columns: SUPPLIERS_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetSuppliers,
        modelPath: SUPPLIER_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetSuppliers: getSuppliers,
  dispatchClearSuppliers: clearSuppliers,
};

const mapStateToProps = ({ FoodUnit }) => ({
  breadcrumbs: [
    ...FoodUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Proveedores',
      href: SUPPLIER_PATH,
    },
  ],
  suppliers: FoodUnit.Supplier.getIn(['all', 'content']),
  loading: FoodUnit.Supplier.getIn(['all', 'loading']),
});

Suppliers.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  suppliers: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetSuppliers: PropTypes.func.isRequired,
  dispatchClearSuppliers: PropTypes.func.isRequired,
};

Suppliers.defaultProps = {
  suppliers: null,
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(Suppliers);
